import ContactActions from '@Components/components/ContactActions';
import AutoColorAvatar from '@Components/General/AutoColorAvatar';
import { Box, Stack, Typography } from '@mui/material';
import {
    adjustHctColor,
    adjustTonalColor,
    adjustTone,
    stringToColor,
} from '@utils/colorUtils';

const ProfilHeader = ({ contact }) => {
    return (
        <Stack
            spacing={2}
            alignItems="center"
            sx={{ p: theme => theme.spacing(4, 3) }}
            bgcolor={adjustTonalColor(stringToColor(contact.display_name), {
                tone: 95,
            })}
            // bgcolor="primaryContainer.main"
        >
            <AutoColorAvatar
                src={contact.profile_picture}
                value={contact.display_name}
                sx={{ width: 120, height: 120, fontSize: 48 }}
            />
            <Box textAlign="center">
                <Typography variant="titleLarge" fontWeight={500}>
                    {contact.display_name}
                </Typography>
                <Typography variant="bodyLarge">
                    {contact.description}
                </Typography>
            </Box>
            <ContactActions buttonProps={{ variant: 'text' }} />
        </Stack>
    );
};

export default ProfilHeader;
